// extracted by mini-css-extract-plugin
export default {"flex-container":"client-profile-content_flex-container__cgh0u"};